import React, { useId } from "react";
import { ChevronDown } from "lucide-react";
import "./SettingsRow.scss";

const SettingsRow = ({ title, status, actionLabel = "Edit", open = false, onToggle, children, done = null }) => {
  const panelId = useId();
  return (
    <section className={`settings-row${open ? " is-open" : ""}${onToggle ? " is-toggle" : ""}`}>
      <div className="settings-row__head">
        {done === null ? null : <span className={`settings-row__dot${done ? " is-done" : ""}`} aria-hidden="true" />}
        <h4 className="settings-row__title">{title}</h4>
        <p className="settings-row__status">{status}</p>
        {onToggle ? (
          <button
            type="button"
            className="settings-row__action"
            aria-expanded={open}
            aria-controls={panelId}
            onClick={onToggle}
          >
            {open ? "Close" : actionLabel}
            <ChevronDown className="settings-row__chevron" size={16} strokeWidth={1.75} aria-hidden="true" />
          </button>
        ) : (
          <span />
        )}
      </div>
      {open ? (
        <div className="settings-row__panel" id={panelId}>
          {children}
        </div>
      ) : null}
    </section>
  );
};

export default SettingsRow;
